module.exports = __webpack_public_path__ + "static/img/bgmodel.d4fb4f8e.png";